import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/static/illustrations/maintenance-rocket.png'


const _withScopeId = n => (_pushScopeId("data-v-646a7fa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "maintenance-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Manutenção",
  class: "rocket-image"
}, null, -1))
const _hoisted_3 = { class: "text-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Estamos ajustando o seu foguete. Segure firme, "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "a decolagem já vai começar!")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", null, "Olá " + _toDisplayString(_ctx.user.name) + "!", 1),
      _hoisted_4
    ])
  ]))
}